import { useState } from 'react'
import { Tag, Button, Popover } from 'antd'
import Feather from '@sysunite/react-feather'

export default ({ groups }) => {
  const content = (
    <div>
    {
      _.map(groups, (obj, item) => (
        <div key={item} style={{ margin: '8px', display: 'list' }}>
          <Tag color={obj.color}>{item}</Tag>
        </div>
      ))
    }
    </div>
  )

  return (
    <Popover placement="topLeft" trigger="click" content={content}>
      <Button type="link" style={{ width: 54, zIndex: 2, position: 'absolute', bottom: 0, left: 0, margin: '16px' }}>
        <Feather type="book-open" />
      </Button>
    </Popover>
  )
}
